const SCROLL_OPTIONS = {
  behavior: 'smooth',
  block: 'center',
};

export const scrollToElement = (element) => {
  if (!element?.scrollIntoView) return;

  element.scrollIntoView(SCROLL_OPTIONS);
};

export const scrollToFirstFormError = (form, errorInfo) => {
  const firstErrorField = errorInfo?.errorFields?.[0]?.name;

  if (!firstErrorField || !form?.scrollToField) return;

  form.scrollToField(firstErrorField, SCROLL_OPTIONS);
};
